module.exports = __webpack_public_path__ + "static/img/employee_man.91dbada6.svg";